// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * VulnerabilitiesPanel — estilos del bloque de vulnerabilidades.
 * Solo variables del sistema de diseño: funciona con cualquier skin.
 */

.vln {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  padding: 18px 20px 20px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

/* ── Cabecera ───────────────────────────────────────────────────────────── */

.vln-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.vln-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  border-radius: var(--radius-md, 10px);
}

.vln-icon svg { width: 20px; height: 20px; }

.vln-icon.is-warn { color: var(--amber-600, #d97706); background: color-mix(in srgb, var(--amber-600, #d97706) 14%, transparent); }
.vln-icon.is-ok   { color: var(--green-600, #16a34a); background: color-mix(in srgb, var(--green-600, #16a34a) 14%, transparent); }

.vln-titles { flex: 1 1 auto; min-width: 0; }
.vln-titles h2 { margin: 0; font-size: 1rem; font-weight: 600; color: var(--text-primary); }
.vln-titles p { margin: 2px 0 0; font-size: 0.8rem; color: var(--text-muted); }

.vln-actions { display: flex; gap: 8px; flex: 0 0 auto; }

/* ── Botones ────────────────────────────────────────────────────────────── */

.vln-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-primary);
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 8px);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.vln-btn:hover:not(:disabled) { border-color: var(--accent); }
.vln-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.vln-btn svg { width: 15px; height: 15px; }

.vln-btn--primary {
  color: #fff;
  background: var(--accent);
  border-color: var(--accent);
}

.vln-btn--primary:hover:not(:disabled) { filter: brightness(1.08); }

.vln-icon-btn {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  color: var(--text-muted);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
}

.vln-icon-btn:hover { color: var(--text-primary); border-color: var(--border); }
.vln-icon-btn svg { width: 16px; height: 16px; }

.is-spinning { animation: vln-spin 0.9s linear infinite; }
@keyframes vln-spin { to { transform: rotate(360deg); } }

/* ── Avisos ─────────────────────────────────────────────────────────────── */

.vln-alert,
.vln-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 0.8rem;
  border-radius: var(--radius-md, 8px);
}

.vln-alert { color: var(--red-700, #b91c1c); background: color-mix(in srgb, var(--red-600, #dc2626) 10%, transparent); }
.vln-notice { color: var(--green-700, #15803d); background: color-mix(in srgb, var(--green-600, #16a34a) 10%, transparent); }
.vln-alert svg, .vln-notice svg { width: 16px; height: 16px; flex: 0 0 16px; }

/* ── KPIs ───────────────────────────────────────────────────────────────── */

.vln-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}

.vln-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 10px);
}

.vln-kpi.is-bad { border-color: color-mix(in srgb, var(--red-600, #dc2626) 40%, var(--border)); }
.vln-kpi-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}
.vln-kpi-label svg { width: 13px; height: 13px; }
.vln-kpi strong { font-size: 1.35rem; font-weight: 650; color: var(--text-primary); line-height: 1.1; }
.vln-kpi.is-bad strong { color: var(--red-600, #dc2626); }
.vln-kpi-hint { font-size: 0.72rem; color: var(--text-muted); }

/* ── Dos columnas ───────────────────────────────────────────────────────── */

.vln-cols {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  gap: 18px;
}

@media (max-width: 900px) {
  .vln-cols { grid-template-columns: 1fr; }
}

.vln-col h3 { margin: 0 0 2px; font-size: 0.85rem; font-weight: 600; color: var(--text-primary); }
.vln-col-hint { margin: 0 0 8px; font-size: 0.75rem; color: var(--text-muted); }

/* ── Tablas ─────────────────────────────────────────────────────────────── */

.vln-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }

.vln-table thead th {
  padding: 6px 8px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: left;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
}

.vln-table td {
  padding: 7px 8px;
  color: var(--text-primary);
  border-bottom: 1px solid color-mix(in srgb, var(--border) 60%, transparent);
}

.vln-table .is-num { text-align: right; font-variant-numeric: tabular-nums; }
.vln-table tbody tr:last-child td { border-bottom: none; }
.vln-table tbody tr.is-clickable { cursor: pointer; }
.vln-table tbody tr.is-clickable:hover { background: var(--bg-toolbar); }
.vln-table tbody tr.is-selected { background: color-mix(in srgb, var(--accent) 8%, transparent); }

.vln-name {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vln-chevron { width: 24px; color: var(--text-muted); }
.vln-chevron svg { width: 14px; height: 14px; }

.vln-cve-id { font-family: var(--font-mono, ui-monospace, monospace); font-size: 0.76rem; }

/* ── Pastillas ──────────────────────────────────────────────────────────── */

.vln-pill {
  display: inline-block;
  padding: 1px 8px;
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 999px;
  border: 1px solid transparent;
}

.vln-pill.is-critical { color: var(--red-700, #b91c1c); background: color-mix(in srgb, var(--red-600, #dc2626) 14%, transparent); }
.vln-pill.is-high { color: var(--orange-700, #c2410c); background: color-mix(in srgb, var(--orange-600, #ea580c) 14%, transparent); }
.vln-pill.is-medium { color: var(--amber-700, #b45309); background: color-mix(in srgb, var(--amber-600, #d97706) 14%, transparent); }
.vln-pill.is-low { color: var(--text-muted); background: var(--bg-toolbar); }
.vln-pill.is-unknown { color: var(--text-muted); background: var(--bg-toolbar); }

.vln-kev {
  display: inline-block;
  padding: 1px 6px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #fff;
  background: var(--red-600, #dc2626);
  border-radius: 4px;
}

/* ── Equipos ────────────────────────────────────────────────────────────── */

.vln-ci-list { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 2px; }

.vln-ci-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
  font-size: 0.8rem;
  border-radius: var(--radius-md, 8px);
}

.vln-ci-list li:hover { background: var(--bg-toolbar); }
.vln-ci-label { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--text-primary); }
.vln-ci-metrics { display: inline-flex; align-items: center; gap: 8px; font-size: 0.74rem; color: var(--text-muted); }
.vln-ci-total { font-weight: 600; color: var(--text-primary); font-variant-numeric: tabular-nums; }

/* ── Vacío y carga ──────────────────────────────────────────────────────── */

.vln-empty {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  background: var(--bg-toolbar);
  border: 1px dashed var(--border);
  border-radius: var(--radius-md, 10px);
}

.vln-empty svg { width: 22px; height: 22px; color: var(--green-600, #16a34a); flex: 0 0 22px; }
.vln-empty strong { display: block; font-size: 0.85rem; color: var(--text-primary); }
.vln-empty p { margin: 4px 0 0; font-size: 0.78rem; color: var(--text-muted); }

.vln-skeleton { display: flex; flex-direction: column; gap: 8px; }
.vln-skeleton span {
  display: block;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(90deg, var(--bg-toolbar) 25%, var(--border) 50%, var(--bg-toolbar) 75%);
  background-size: 200% 100%;
  animation: vln-shimmer 1.3s ease-in-out infinite;
}

@keyframes vln-shimmer { to { background-position: -200% 0; } }

/* ── Modal de CVEs ──────────────────────────────────────────────────────── */

.vln-modal {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
}

.vln-modal-card {
  display: flex;
  flex-direction: column;
  width: min(880px, 100%);
  max-height: min(80vh, 760px);
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
  overflow: hidden;
}

.vln-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
}

.vln-modal-head h3 { margin: 0; font-size: 0.95rem; color: var(--text-primary); }
.vln-modal-head p { margin: 2px 0 0; font-size: 0.76rem; color: var(--text-muted); }

.vln-modal-body { flex: 1 1 auto; overflow: auto; padding: 4px 16px 8px; }

.vln-table--cves thead th {
  position: sticky;
  top: 0;
  background: var(--bg-card);
  z-index: 1;
}

.vln-modal-foot {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  padding: 12px 16px;
  background: var(--bg-toolbar);
  border-top: 1px solid var(--border);
}

.vln-reason { flex: 1 1 auto; min-width: 0; }
.vln-reason label {
  display: block;
  margin-bottom: 4px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.vln-reason textarea {
  width: 100%;
  padding: 7px 9px;
  font-family: inherit;
  font-size: 0.8rem;
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 8px);
  resize: vertical;
}

.vln-reason textarea:focus { outline: none; border-color: var(--accent); }

.vln-modal-actions { display: flex; align-items: center; gap: 8px; flex: 0 0 auto; }
.vln-selected { font-size: 0.75rem; color: var(--text-muted); white-space: nowrap; }

/* ── Móvil: el grid se apilaba pero las columnas seguían midiendo 382 px ──
   Un elemento de grid no baja de su \`min-width: auto\` (el ancho mínimo del
   contenido). En el dashboard de estaciones eso hacía que la lista de equipos
   se saliera 95 px de la tarjeta. */
.vln-col {
  min-width: 0;
}

@media (max-width: 768px) {
  /* Las tablas de CVEs tienen 5 columnas y no bajan de ~420 px: en vez de
     cortarse por la derecha, se deslizan dentro de su columna. */
  .vln-col {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .vln-ci-list,
  .vln-ci-item {
    min-width: 0;
    max-width: 100%;
  }

  .vln-ci-list {
    overflow-wrap: anywhere;
  }

  .vln-table {
    font-size: 0.74rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VulnerabilitiesPanel.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE;;AAE3C,oBAAoB,gCAAgC,EAAE,0EAA0E,EAAE;AAClI,oBAAoB,gCAAgC,EAAE,0EAA0E,EAAE;;AAElI,cAAc,cAAc,EAAE,YAAY,EAAE;AAC5C,iBAAiB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC3F,gBAAgB,eAAe,EAAE,iBAAiB,EAAE,wBAAwB,EAAE;;AAE9E,eAAe,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAExD,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,oCAAoC;EACpC,eAAe;EACf,0DAA0D;AAC5D;;AAEA,gCAAgC,2BAA2B,EAAE;AAC7D,oBAAoB,aAAa,EAAE,mBAAmB,EAAE;AACxD,eAAe,WAAW,EAAE,YAAY,EAAE;;AAE1C;EACE,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,yCAAyC,wBAAwB,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB,0BAA0B,EAAE,2BAA2B,EAAE;AAC/E,oBAAoB,WAAW,EAAE,YAAY,EAAE;;AAE/C,eAAe,wCAAwC,EAAE;AACzD,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;;AAExD,8EAA8E;;AAE9E;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,aAAa,8BAA8B,EAAE,wEAAwE,EAAE;AACvH,cAAc,gCAAgC,EAAE,0EAA0E,EAAE;AAC5H,kCAAkC,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAE7E,8EAA8E;;AAE9E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA,kBAAkB,4EAA4E,EAAE;AAChG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA,qBAAqB,WAAW,EAAE,YAAY,EAAE;AAChD,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACtG,yBAAyB,8BAA8B,EAAE;AACzD,gBAAgB,kBAAkB,EAAE,wBAAwB,EAAE;;AAE9D,8EAA8E;;AAE9E;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;AACX;;AAEA;EACE,YAAY,0BAA0B,EAAE;AAC1C;;AAEA,cAAc,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACjG,gBAAgB,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAE/E,8EAA8E;;AAE9E,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;;AAExE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,2EAA2E;AAC7E;;AAEA,qBAAqB,iBAAiB,EAAE,kCAAkC,EAAE;AAC5E,oCAAoC,mBAAmB,EAAE;AACzD,mCAAmC,eAAe,EAAE;AACpD,yCAAyC,6BAA6B,EAAE;AACxE,kCAAkC,6DAA6D,EAAE;;AAEjG;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,eAAe,WAAW,EAAE,wBAAwB,EAAE;AACtD,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C,cAAc,sDAAsD,EAAE,kBAAkB,EAAE;;AAE1F,8EAA8E;;AAE9E;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,wBAAwB,8BAA8B,EAAE,wEAAwE,EAAE;AAClI,oBAAoB,iCAAiC,EAAE,2EAA2E,EAAE;AACpI,sBAAsB,gCAAgC,EAAE,0EAA0E,EAAE;AACpI,mBAAmB,wBAAwB,EAAE,6BAA6B,EAAE;AAC5E,uBAAuB,wBAAwB,EAAE,6BAA6B,EAAE;;AAEhF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,8EAA8E;;AAE9E,eAAe,SAAS,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEzG;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,wBAAwB,6BAA6B,EAAE;AACvD,gBAAgB,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,0BAA0B,EAAE;AAC1I,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AACrH,gBAAgB,gBAAgB,EAAE,0BAA0B,EAAE,kCAAkC,EAAE;;AAElG,8EAA8E;;AAE9E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,iBAAiB,WAAW,EAAE,YAAY,EAAE,gCAAgC,EAAE,cAAc,EAAE;AAC9F,oBAAoB,cAAc,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACpF,eAAe,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAE9E,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mGAAmG;EACnG,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA,yBAAyB,KAAK,4BAA4B,EAAE,EAAE;;AAE9D,8EAA8E;;AAE9E;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,qBAAqB,SAAS,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAChF,oBAAoB,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAEnF,kBAAkB,cAAc,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAEzE;EACE,gBAAgB;EAChB,MAAM;EACN,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,cAAc,cAAc,EAAE,YAAY,EAAE;AAC5C;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,6BAA6B,aAAa,EAAE,2BAA2B,EAAE;;AAEzE,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACnF,gBAAgB,kBAAkB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;;AAEnF;;;oCAGoC;AACpC;EACE,YAAY;AACd;;AAEA;EACE;iEAC+D;EAC/D;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/**\r\n * VulnerabilitiesPanel — estilos del bloque de vulnerabilidades.\r\n * Solo variables del sistema de diseño: funciona con cualquier skin.\r\n */\r\n\r\n.vln {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n  padding: 18px 20px 20px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n}\r\n\r\n/* ── Cabecera ───────────────────────────────────────────────────────────── */\r\n\r\n.vln-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n}\r\n\r\n.vln-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  flex: 0 0 38px;\r\n  border-radius: var(--radius-md, 10px);\r\n}\r\n\r\n.vln-icon svg { width: 20px; height: 20px; }\r\n\r\n.vln-icon.is-warn { color: var(--amber-600, #d97706); background: color-mix(in srgb, var(--amber-600, #d97706) 14%, transparent); }\r\n.vln-icon.is-ok   { color: var(--green-600, #16a34a); background: color-mix(in srgb, var(--green-600, #16a34a) 14%, transparent); }\r\n\r\n.vln-titles { flex: 1 1 auto; min-width: 0; }\r\n.vln-titles h2 { margin: 0; font-size: 1rem; font-weight: 600; color: var(--text-primary); }\r\n.vln-titles p { margin: 2px 0 0; font-size: 0.8rem; color: var(--text-muted); }\r\n\r\n.vln-actions { display: flex; gap: 8px; flex: 0 0 auto; }\r\n\r\n/* ── Botones ────────────────────────────────────────────────────────────── */\r\n\r\n.vln-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-md, 8px);\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.vln-btn:hover:not(:disabled) { border-color: var(--accent); }\r\n.vln-btn:disabled { opacity: 0.55; cursor: not-allowed; }\r\n.vln-btn svg { width: 15px; height: 15px; }\r\n\r\n.vln-btn--primary {\r\n  color: #fff;\r\n  background: var(--accent);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.vln-btn--primary:hover:not(:disabled) { filter: brightness(1.08); }\r\n\r\n.vln-icon-btn {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  color: var(--text-muted);\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.vln-icon-btn:hover { color: var(--text-primary); border-color: var(--border); }\r\n.vln-icon-btn svg { width: 16px; height: 16px; }\r\n\r\n.is-spinning { animation: vln-spin 0.9s linear infinite; }\r\n@keyframes vln-spin { to { transform: rotate(360deg); } }\r\n\r\n/* ── Avisos ─────────────────────────────────────────────────────────────── */\r\n\r\n.vln-alert,\r\n.vln-notice {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  font-size: 0.8rem;\r\n  border-radius: var(--radius-md, 8px);\r\n}\r\n\r\n.vln-alert { color: var(--red-700, #b91c1c); background: color-mix(in srgb, var(--red-600, #dc2626) 10%, transparent); }\r\n.vln-notice { color: var(--green-700, #15803d); background: color-mix(in srgb, var(--green-600, #16a34a) 10%, transparent); }\r\n.vln-alert svg, .vln-notice svg { width: 16px; height: 16px; flex: 0 0 16px; }\r\n\r\n/* ── KPIs ───────────────────────────────────────────────────────────────── */\r\n\r\n.vln-kpis {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.vln-kpi {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  padding: 10px 12px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-md, 10px);\r\n}\r\n\r\n.vln-kpi.is-bad { border-color: color-mix(in srgb, var(--red-600, #dc2626) 40%, var(--border)); }\r\n.vln-kpi-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--text-muted);\r\n}\r\n.vln-kpi-label svg { width: 13px; height: 13px; }\r\n.vln-kpi strong { font-size: 1.35rem; font-weight: 650; color: var(--text-primary); line-height: 1.1; }\r\n.vln-kpi.is-bad strong { color: var(--red-600, #dc2626); }\r\n.vln-kpi-hint { font-size: 0.72rem; color: var(--text-muted); }\r\n\r\n/* ── Dos columnas ───────────────────────────────────────────────────────── */\r\n\r\n.vln-cols {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);\r\n  gap: 18px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .vln-cols { grid-template-columns: 1fr; }\r\n}\r\n\r\n.vln-col h3 { margin: 0 0 2px; font-size: 0.85rem; font-weight: 600; color: var(--text-primary); }\r\n.vln-col-hint { margin: 0 0 8px; font-size: 0.75rem; color: var(--text-muted); }\r\n\r\n/* ── Tablas ─────────────────────────────────────────────────────────────── */\r\n\r\n.vln-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }\r\n\r\n.vln-table thead th {\r\n  padding: 6px 8px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  text-align: left;\r\n  color: var(--text-muted);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.vln-table td {\r\n  padding: 7px 8px;\r\n  color: var(--text-primary);\r\n  border-bottom: 1px solid color-mix(in srgb, var(--border) 60%, transparent);\r\n}\r\n\r\n.vln-table .is-num { text-align: right; font-variant-numeric: tabular-nums; }\r\n.vln-table tbody tr:last-child td { border-bottom: none; }\r\n.vln-table tbody tr.is-clickable { cursor: pointer; }\r\n.vln-table tbody tr.is-clickable:hover { background: var(--bg-toolbar); }\r\n.vln-table tbody tr.is-selected { background: color-mix(in srgb, var(--accent) 8%, transparent); }\r\n\r\n.vln-name {\r\n  max-width: 240px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.vln-chevron { width: 24px; color: var(--text-muted); }\r\n.vln-chevron svg { width: 14px; height: 14px; }\r\n\r\n.vln-cve-id { font-family: var(--font-mono, ui-monospace, monospace); font-size: 0.76rem; }\r\n\r\n/* ── Pastillas ──────────────────────────────────────────────────────────── */\r\n\r\n.vln-pill {\r\n  display: inline-block;\r\n  padding: 1px 8px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  border-radius: 999px;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.vln-pill.is-critical { color: var(--red-700, #b91c1c); background: color-mix(in srgb, var(--red-600, #dc2626) 14%, transparent); }\r\n.vln-pill.is-high { color: var(--orange-700, #c2410c); background: color-mix(in srgb, var(--orange-600, #ea580c) 14%, transparent); }\r\n.vln-pill.is-medium { color: var(--amber-700, #b45309); background: color-mix(in srgb, var(--amber-600, #d97706) 14%, transparent); }\r\n.vln-pill.is-low { color: var(--text-muted); background: var(--bg-toolbar); }\r\n.vln-pill.is-unknown { color: var(--text-muted); background: var(--bg-toolbar); }\r\n\r\n.vln-kev {\r\n  display: inline-block;\r\n  padding: 1px 6px;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n  color: #fff;\r\n  background: var(--red-600, #dc2626);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* ── Equipos ────────────────────────────────────────────────────────────── */\r\n\r\n.vln-ci-list { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 2px; }\r\n\r\n.vln-ci-list li {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 6px 8px;\r\n  font-size: 0.8rem;\r\n  border-radius: var(--radius-md, 8px);\r\n}\r\n\r\n.vln-ci-list li:hover { background: var(--bg-toolbar); }\r\n.vln-ci-label { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--text-primary); }\r\n.vln-ci-metrics { display: inline-flex; align-items: center; gap: 8px; font-size: 0.74rem; color: var(--text-muted); }\r\n.vln-ci-total { font-weight: 600; color: var(--text-primary); font-variant-numeric: tabular-nums; }\r\n\r\n/* ── Vacío y carga ──────────────────────────────────────────────────────── */\r\n\r\n.vln-empty {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  padding: 14px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px dashed var(--border);\r\n  border-radius: var(--radius-md, 10px);\r\n}\r\n\r\n.vln-empty svg { width: 22px; height: 22px; color: var(--green-600, #16a34a); flex: 0 0 22px; }\r\n.vln-empty strong { display: block; font-size: 0.85rem; color: var(--text-primary); }\r\n.vln-empty p { margin: 4px 0 0; font-size: 0.78rem; color: var(--text-muted); }\r\n\r\n.vln-skeleton { display: flex; flex-direction: column; gap: 8px; }\r\n.vln-skeleton span {\r\n  display: block;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  background: linear-gradient(90deg, var(--bg-toolbar) 25%, var(--border) 50%, var(--bg-toolbar) 75%);\r\n  background-size: 200% 100%;\r\n  animation: vln-shimmer 1.3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes vln-shimmer { to { background-position: -200% 0; } }\r\n\r\n/* ── Modal de CVEs ──────────────────────────────────────────────────────── */\r\n\r\n.vln-modal {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 60;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 24px;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  backdrop-filter: blur(2px);\r\n}\r\n\r\n.vln-modal-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: min(880px, 100%);\r\n  max-height: min(80vh, 760px);\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);\r\n  overflow: hidden;\r\n}\r\n\r\n.vln-modal-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 14px 16px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.vln-modal-head h3 { margin: 0; font-size: 0.95rem; color: var(--text-primary); }\r\n.vln-modal-head p { margin: 2px 0 0; font-size: 0.76rem; color: var(--text-muted); }\r\n\r\n.vln-modal-body { flex: 1 1 auto; overflow: auto; padding: 4px 16px 8px; }\r\n\r\n.vln-table--cves thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  background: var(--bg-card);\r\n  z-index: 1;\r\n}\r\n\r\n.vln-modal-foot {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 14px;\r\n  padding: 12px 16px;\r\n  background: var(--bg-toolbar);\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.vln-reason { flex: 1 1 auto; min-width: 0; }\r\n.vln-reason label {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.vln-reason textarea {\r\n  width: 100%;\r\n  padding: 7px 9px;\r\n  font-family: inherit;\r\n  font-size: 0.8rem;\r\n  color: var(--text-primary);\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-md, 8px);\r\n  resize: vertical;\r\n}\r\n\r\n.vln-reason textarea:focus { outline: none; border-color: var(--accent); }\r\n\r\n.vln-modal-actions { display: flex; align-items: center; gap: 8px; flex: 0 0 auto; }\r\n.vln-selected { font-size: 0.75rem; color: var(--text-muted); white-space: nowrap; }\r\n\r\n/* ── Móvil: el grid se apilaba pero las columnas seguían midiendo 382 px ──\r\n   Un elemento de grid no baja de su `min-width: auto` (el ancho mínimo del\r\n   contenido). En el dashboard de estaciones eso hacía que la lista de equipos\r\n   se saliera 95 px de la tarjeta. */\r\n.vln-col {\r\n  min-width: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  /* Las tablas de CVEs tienen 5 columnas y no bajan de ~420 px: en vez de\r\n     cortarse por la derecha, se deslizan dentro de su columna. */\r\n  .vln-col {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .vln-ci-list,\r\n  .vln-ci-item {\r\n    min-width: 0;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .vln-ci-list {\r\n    overflow-wrap: anywhere;\r\n  }\r\n\r\n  .vln-table {\r\n    font-size: 0.74rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
